<template>
  <div>
    <b-card no-body border-variant="light" class="mb-2 mt-3">
      <table class="table mb-0">
        <thead>
          <tr class="bg-gray-200 small">
            <th>Ár</th>
            <th class="text-right">Upphæð</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="year in yearList" :key="year.year">
            <td>{{ year.year }}</td>
            <td align="right">{{ year.wages | currency }}</td>
          </tr>
          <tr v-if="yearList.length === 0">
            <td colspan="100%" class="text-center"><i>Engar niðurstöður fundust</i></td>
          </tr>
        </tbody>
      </table>
    </b-card>
    <pagination
      v-if="pagination && pagination.totalPages > 1"
      :pagination-response="pagination"
      @change-limit="changeLimit"
      @change-page="changePage"
    >
    </pagination>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import payment from '@/api/payment';
import Pagination from '@/components/Pagination.vue';
import { paginationMixin, parsePagination } from '@/utils';

export default {
  name: 'year-overview',
  props: ['active'],
  components: {
    Pagination,
  },
  mixins: [paginationMixin],
  data() {
    return {
      page: null,
      pagination: null,
      loading: false,
      yearList: [],
    };
  },
  methods: {
    async loadList(page = null, limit = null) {
      this.loading = true;
      this.yearList = [];
      try {
        const response = await payment.paymentBatchOverviewYearList(page, limit);
        this.yearList = response.data;
        this.pagination = parsePagination(response);
        // await this.setLoggedInUserOption({ option: 'application', value: this.options.application });
        // await this.saveLoggedInUserOptions();
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.loading = false;
      }
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
  watch: {
    active(val) {
      if (val) {
        this.loadList();
      }
    },
  },
  created() {
    if (this.active) {
      this.loadList();
    }
  },
};
</script>
